import gql from 'graphql-tag'

export const SUBSCRIBE_TRANSFER_POINT_HISTORY = gql`
    subscription subscribeTransferPointHistory($partnerId:uuid!,$schemeId:uuid!,$startDate:timestamptz!,$endDate:timestamptz!){
        SchemePointsHistoryOrderWise(where:{partnerId:{_eq:$partnerId},schemeId:{_eq:$schemeId}, Order:{date:{_gte:$startDate,_lte:$endDate}}, transferPoint: {_neq: 0}},distinct_on:orderId, order_by: {orderId: asc, Order: {createdOn: desc}}){
            id
            transferPoint
            createdOn           
            Order{
                id
                from
                status
                createdOn
                orderNum
                invoiceNumber
                invoiceDate
                invoiceNote
                date
                orderType                
                OrderItems{
                    productId
                    ToOrganization{name PartnerType{name prefix} }
                    ToCustomer{name}
                    FromOrganization{name PartnerType{name prefix} }
                    orderItemId: id
                    orderItemStatus: status
                    Product{name id productLineCode ProductLine{name} OEM {name}}
                    Batch{batch id productId status sku}
                }}
        }
    }
`